// components/Hero.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import slide1 from '../assets/images/1.jpeg';
import slide2 from '../assets/images/2.jpeg';
import slide3 from '../assets/images/3.jpeg';

function Hero() {
  // Google Form URL - replace with your actual form URL
  const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSdi4L_WXjGMh3qlycRiTLnkTHmQeZ5OuP5NhyMH34TVjMQiNQ/viewform?usp=header";
  
  return (
    <section className="slider_section">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        className="mySwiper"
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="slider_bg_box">
            <img src={slide1} alt="Transport Service 1" />
          </div>
          <div className="container">
            <div className="detail-box">
              <h1>We Provide the Best Transport Service</h1>
              <p>We provide seamless logistics solutions to Rwanda, Burundi, Congo, Zambia, Malawi, and the Democratic Republic of Congo (DRC).</p>
              
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="slider_bg_box">
            <img src={slide2} alt="Transport Service 2" />
          </div>
          <div className="container">
            <div className="detail-box">
              <h1>Professional Logistics Solutions</h1>
              <p>We pride ourselves on our ability to handle diverse logistics challenges while maintaining the highest standards of professionalism.</p>
              
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <div className="slider_bg_box">
            <img src={slide3} alt="Transport Service 3" />
          </div>
          <div className="container">
            <div className="detail-box">
              <h1>Customized Transport Solutions</h1>
              <p>Whether you're transporting industrial equipment, agricultural products, or consumer goods, we provide customized solutions tailored to your needs.</p>
              
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}

export default Hero;